import usePermissions from "./usePermissions";

export default usePermissions;
